import React, { useState } from "react";
import "./Pages/PagesCss/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="atp-contact-main">
      {/* Hero Section */}
      <div className="atp-contact-hero">
        <div className="atp-hero-content">
          <div className="atp-hero-badge">
            <i className="fa-solid fa-comments"></i>
            Get In Touch
          </div>
          <h1 className="atp-hero-title">
            Your Financial Questions
            <span className="atp-gradient-text"> Answered Instantly</span>
          </h1>
          <p className="atp-hero-subtitle">
            Curious about payroll, taxes, or property calculations? Our tools make it easy to find accurate answers quickly and efficiently.
          </p>
        </div>
        <div className="atp-hero-visual">
          <div className="atp-floating-icon">
            <i className="fa-solid fa-envelope"></i>
          </div>
        </div>
      </div>

      <div className="atp-contact-container">
        {/* Contact Cards */}
        <div className="atp-contact-section">
          <div className="atp-section-header">
            <h2>Quick Contact</h2>
            <p>Reach out through any of these channels</p>
          </div>
          
          <div className="atp-contact-cards">
            <div className="atp-contact-card">
              <div className="atp-card-icon">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <div className="atp-card-content">
                <h3>Our Office</h3>
                <p>2568 Madison Ave, League City, TX 77573, USA</p>
                <button className="atp-card-action">
                  <i className="fa-solid fa-directions"></i>
                  Get Directions
                </button>
              </div>
            </div>

            <div className="atp-contact-card">
              <div className="atp-card-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <div className="atp-card-content">
                <h3>Email Us</h3>
                <p>We'll respond within 24 hours</p>
                <a href="mailto:support@aftertaxpay.com" className="atp-card-action">
                  <i className="fa-solid fa-paper-plane"></i>
                  support@aftertaxpay.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form & Map Section */}
        <div className="atp-contact-content">
          {/* Contact Form */}
          <div className="atp-form-section">
            <div className="atp-form-header">
              <h2>Send us a Message</h2>
              <p>Fill out the form below and we'll get back to you shortly</p>
            </div>
            
            <form className="atp-contact-form" onSubmit={handleSubmit}>
              <div className="atp-form-row">
                <div className="atp-form-group">
                  <label htmlFor="name">Full Name</label>
                  <div className="atp-input-wrapper">
                    <i className="fa-solid fa-user"></i>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                </div>
                
                <div className="atp-form-group">
                  <label htmlFor="email">Email Address</label>
                  <div className="atp-input-wrapper">
                    <i className="fa-solid fa-envelope"></i>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="atp-form-group">
                <label htmlFor="subject">Subject</label>
                <div className="atp-input-wrapper">
                  <i className="fa-solid fa-tag"></i>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="What is this regarding?"
                    required
                  />
                </div>
              </div>

              <div className="atp-form-group">
                <label htmlFor="message">Message</label>
                <div className="atp-input-wrapper">
                  <i className="fa-solid fa-message"></i>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your inquiry..."
                    rows="5"
                    required
                  ></textarea>
                </div>
              </div>

              <button type="submit" className="atp-submit-btn">
                <i className="fa-solid fa-paper-plane"></i>
                Send Message
              </button>
            </form>
          </div>

          {/* Map Section */}
          <div className="atp-map-section">
            <div className="atp-map-header">
              <h3>Visit Our Office</h3>
              <p>Come see us in League City, Texas</p>
            </div>
            
            <div className="atp-contact-map">
              <iframe
                title="Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.123456789!2d-95.079!3d29.507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640f123456789ab%3A0xabcdef123456789!2s2568%20Madison%20Ave%2C%20League%20City%2C%20TX%2077573%2C%20USA!5e0!3m2!1sen!2sus!4v169XXXXXXX"
                loading="lazy"
                allowFullScreen
              ></iframe>
              
              <div className="atp-map-overlay">
                <div className="atp-overlay-content">
                  <h4>AfterTaxPay Headquarters</h4>
                  <p>2568 Madison Ave, League City, TX 77573</p>
                  <div className="atp-overlay-actions">
                    <button className="atp-overlay-btn">
                      <i className="fa-solid fa-directions"></i>
                      Directions
                    </button>
                    {/* <button className="atp-overlay-btn">
                      <i className="fa-solid fa-phone"></i>
                      Call
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="atp-faq-section">
          <div className="atp-section-header">
            <h2>Frequently Asked Questions</h2>
            <p>Quick answers to common questions</p>
          </div>
          
          <div className="atp-faq-grid">
            <div className="atp-faq-item">
              <div className="atp-faq-icon">
                <i className="fa-solid fa-calculator"></i>
              </div>
              <div className="atp-faq-content">
                <h4>How accurate are your calculators?</h4>
                <p>Our calculators use current tax rates and formulas to provide accurate estimates. For exact figures, consult with a tax professional.</p>
              </div>
            </div>
            
            <div className="atp-faq-item">
              <div className="atp-faq-icon">
                <i className="fa-solid fa-lock"></i>
              </div>
              <div className="atp-faq-content">
                <h4>Is my data secure?</h4>
                <p>Yes! We don't store any personal financial data. All calculations are done locally in your browser.</p>
              </div>
            </div>
            
            <div className="atp-faq-item">
              <div className="atp-faq-icon">
                <i className="fa-solid fa-clock"></i>
              </div>
              <div className="atp-faq-content">
                <h4>How quickly do you respond?</h4>
                <p>We typically respond to all inquiries within 24 hours during business days.</p>
              </div>
            </div>

            <div className="atp-faq-item">
  <div className="atp-faq-icon">
    <i className="fas fa-mobile-alt"></i>
  </div>
  <div className="atp-faq-content">
    <h4>Can I use this on mobile devices?</h4>
    <p>Yes! Our platform is fully responsive and works on all mobile devices, tablets, and desktops.</p>
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
